import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import qs from 'query-string'
import { QS_CONFIG_ARRAY_ENCODED } from '../../../features/common/Utilities'

export async function getMetaFormsData({ search }){
    let query = qs.parse(search, QS_CONFIG_ARRAY_ENCODED)
    const {
        pageId, 
        page, 
        per_page,
        configuration = '', 
    } = query

    try {
        if (pageId && pageId !== "undefined"){
            let response = await axios.get(`${LEADS_ENDPOINT}/getMetaFormData?meta_page=${pageId}&page=${page}&per_page=${per_page}${configuration ? `&configuration=${configuration}`:''}${query.sort ? `&sort=${query.sort}`:''}${query.search ? `&search=${query.search}`:''}`)

            return {
                data: response?.data?.data,
                pagination: response?.data?.pagination
            }
        }
    } catch (error) {
        throw new Error(error)
    }
}
